<div class="modal-content">
  <user-form
    [isEditMode]="isEditMode"
    [data]="item"
    (processCompleted)="onProcessCompleted($event)"></user-form>
</div>
